<template>
  <transition mode="out-in" appear @enter="enter" @leave="leave" :css="false">
    <div class="wrapper">
      <FrameBook></FrameBook>
      <div class="paradigm-slick">
        <section class="paradigm">
          <div class="paradigm__bg">
            <div class="paradigm__bg-view"></div>
          </div>

          <div class="paradigm__contents">
            <div class="paradigm__txt">
              <div class="paradigm__txt-bg"></div>
              <div class="paradigm__txt-bl">
                <span class="bl--1"></span><span class="bl--2"></span
                ><span class="bl--3"></span>
                <hr class="bl--r" />
                <hr class="bl--l" />
              </div>
              <div
                class="paradigm__txt-tit"
                v-html="$t('paradigm.flicking-1.title')"
              ></div>
              <div
                class="paradigm__txt-desc"
                v-html="$t('paradigm.flicking-1.desc')"
              ></div>
              <div
                class="paradigm__txt-desc2"
                v-html="$t('paradigm.flicking-1.desc2')"
              ></div>
            </div>
          </div>
        </section>
        <section class="paradigm">
          <div class="paradigm__bg">
            <div class="paradigm__bg-view"></div>
          </div>
          <div class="paradigm__contents">
            <div class="paradigm__txt">
              <div class="paradigm__txt-bg"></div>
              <div class="paradigm__txt-bl">
                <span class="bl--1"></span><span class="bl--2"></span
                ><span class="bl--3"></span>
                <hr class="bl--r" />
                <hr class="bl--l" />
              </div>
              <div
                class="paradigm__txt-tit"
                v-html="$t('paradigm.flicking-2.title')"
              ></div>
              <div
                class="paradigm__txt-desc"
                v-html="$t('paradigm.flicking-2.desc')"
              ></div>
            </div>
          </div>
          <div class="paradigm__chatting">
            <div class="paradigm__chatting-view"></div>
          </div>
        </section>
        <section class="paradigm">
          <div class="paradigm__bg">
            <div class="paradigm__bg-view"></div>
          </div>

          <div class="paradigm__contents">
            <div class="paradigm__txt">
              <div class="paradigm__txt-bg"></div>
              <div class="paradigm__txt-bl">
                <span class="bl--1"></span><span class="bl--2"></span
                ><span class="bl--3"></span>
                <hr class="bl--r" />
                <hr class="bl--l" />
              </div>
              <div
                class="paradigm__txt-tit"
                v-html="$t('paradigm.flicking-3.title')"
              ></div>
              <div
                class="paradigm__txt-desc"
                v-html="$t('paradigm.flicking-3.desc')"
              ></div>
              <div
                class="paradigm__txt-desc2"
                v-html="$t('paradigm.flicking-3.desc2')"
              ></div>
            </div>
          </div>
        </section>
        <section class="paradigm">
          <div class="paradigm__bg">
            <div class="paradigm__bg-view"></div>
          </div>

          <div class="paradigm__contents">
            <div class="paradigm__txt">
              <div class="paradigm__txt-bg"></div>
              <div class="paradigm__txt-bl">
                <span class="bl--1"></span><span class="bl--2"></span
                ><span class="bl--3"></span>
                <hr class="bl--r" />
                <hr class="bl--l" />
              </div>
              <div
                class="paradigm__txt-tit"
                v-html="$t('paradigm.flicking-4.title')"
              ></div>
              <div
                class="paradigm__txt-desc"
                v-html="$t('paradigm.flicking-4.desc')"
              ></div>
              <div
                class="paradigm__txt-desc2"
                v-html="$t('paradigm.flicking-4.desc2')"
              ></div>
            </div>
          </div>
        </section>
      </div>
      <ScrollBtn></ScrollBtn>
    </div>
  </transition>
</template>

<script>
import BaseSection from "./mixins/BaseSection.js";
import gsap from "gsap";
import FrameBook from "@/components/FrameBook";
import ScrollBtn from "../components/ScrollBtn";

export default {
  name: "paradigm",
  components: { FrameBook, ScrollBtn },
  mixins: [BaseSection],
  data() {
    return {
      name: "paradigm",
      bg: null,
      titMotion: null,
      slickOptions: {
        arrows: true,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        initialSlide: 3,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        pauseOnHover: true,
      },
    };
  },
  methods: {
    setMotion() {
      this.enterMotion = new gsap.timeline({
        paused: true,
        onStart: () => {
          this.setIsMovePage(true);
        },
      });
      this.enterMotion
        .addLabel("start")
        .from(this.$el, 0.5, { opacity: 0, ease: "power2.easeOut" });

      // this.titMotion = new gsap.timeline({ paused: true });
      // this.titMotion
      //   .addLabel("title")
      //   //  .to(this.$el.querySelector(`.coming__bg-img`), 3,{ autoAlpha:1}, 'title')
      //   .fromTo(
      //     this.$el.querySelector(`.${this.name}__txt .bl--1`),
      //     0.4,
      //     { autoAlpha: 0, rotation: 190 },
      //     { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
      //     "title"
      //   )
      //   .fromTo(
      //     this.$el.querySelector(`.${this.name}__txt .bl--2`),
      //     0.4,
      //     { autoAlpha: 0, rotation: -190 },
      //     { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
      //     "title"
      //   )
      //   .fromTo(
      //     this.$el.querySelector(`.${this.name}__txt .bl--3`),
      //     0.4,
      //     { autoAlpha: 0, scale: 3 },
      //     { autoAlpha: 1, scale: 1, ease: "Back.easeOut" },
      //     "title"
      //   )
      //   .fromTo(
      //     this.$el.querySelector(`.${this.name}__txt .bl--r`),
      //     0.4,
      //     { autoAlpha: 0, x: -30, y: -5 },
      //     { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
      //     "title+=0.2"
      //   )
      //   .fromTo(
      //     this.$el.querySelector(`.${this.name}__txt .bl--l`),
      //     0.4,
      //     { autoAlpha: 0, x: 30, y: -5 },
      //     { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
      //     "title+=0.2"
      //   )
      //   .fromTo(
      //     this.$el.querySelector(`.${this.name}__txt-bg`),
      //     0.4,
      //     { autoAlpha: 0, y: -10 },
      //     { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
      //     "title+=0.2"
      //   )
      //   .fromTo(
      //     this.$el.querySelector(`.${this.name}__txt-tit`),
      //     0.4,
      //     { autoAlpha: 0, y: 30 },
      //     { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
      //     "title+=0.4"
      //   )
      //   .fromTo(
      //     this.$el.querySelector(`.${this.name}__txt-desc`),
      //     0.4,
      //     { autoAlpha: 0, y: -30 },
      //     { autoAlpha: 0.4, y: 0, ease: "expo.easeOut" },
      //     "title+=0.6"
      //   )
      //   .fromTo(
      //     this.$el.querySelector(`.${this.name}__txt-desc2`),
      //     0.4,
      //     { autoAlpha: 0, y: -30 },
      //     { autoAlpha: 0.4, y: 0, ease: "expo.easeOut" },
      //     "title+=0.8"
      //   )
      //   .fromTo(
      //     this.$el.querySelector(`.scroll-btn`),
      //     0.5,
      //     { autoAlpha: 0, y: 30 },
      //     { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
      //     "title+=0.2"
      //   );
    },
    leave(el, done) {
      gsap.to(this.$el, 0.5, { opacity: 0, onComplete: done });
      $(".paradigm-slick").slick("unslick");
    },
    enter(el, done) {
      this.setMotion();

      this.enterMotion.eventCallback("onComplete", () => {
        done();
        this.setIsMovePage(false);
      });
      if (this.currentPage == "index") this.autoPlay = false;
      this.setCurrentPage(this.name);
      this.setEnterPage(this);
    },
    start() {
      this.enterMotion.play();
      //this.titMotion.play();
    },
  },
  mounted() {
    $(".paradigm-slick")
      .slick(this.slickOptions)
      .on("beforeChange", function (event, slick, currentSlide) {
        $(
          ".paradigm__txt-bl .bl--1, .paradigm__txt-bl .bl--2, .paradigm__txt-bl .bl--3, .paradigm__txt-bl .bl--r, .paradigm__txt-bl .bl--l, .paradigm__txt-bg, .paradigm__txt-tit, .paradigm__txt-desc, .paradigm__txt-desc2, .paradigm__chatting-view, .scroll-btn"
        ).css("opacity", 0);
      })
      .on("afterChange", function (event, slick, currentSlide) {
        const t1 = gsap.timeline();

        t1.addLabel("title")
          .fromTo(
            ".paradigm__txt-bl .bl--1",
            0.4,
            { autoAlpha: 0, rotation: 190 },
            { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
            "title"
          )
          .fromTo(
            ".paradigm__txt-bl .bl--2",
            0.4,
            { autoAlpha: 0, rotation: -190 },
            { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
            "title"
          )
          .fromTo(
            ".paradigm__txt-bl .bl--3",
            0.4,
            { autoAlpha: 0, scale: 3 },
            { autoAlpha: 1, scale: 1, ease: "Back.easeOut" },
            "title"
          )
          .fromTo(
            ".paradigm__txt-bl .bl--r",
            0.4,
            { autoAlpha: 0, x: -30, y: -5 },
            { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
            "title+=0.2"
          )
          .fromTo(
            ".paradigm__txt-bl .bl--l",
            0.4,
            { autoAlpha: 0, x: 30, y: -5 },
            { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
            "title+=0.2"
          )
          .fromTo(
            ".paradigm__txt-bg",
            0.4,
            { autoAlpha: 0, y: -10 },
            { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
            "title+=0.2"
          )
          .fromTo(
            ".paradigm__txt-tit",
            0.4,
            { autoAlpha: 0, y: 30 },
            { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
            "title+=0.4"
          )
          .fromTo(
            ".paradigm__txt-desc",
            0.4,
            { autoAlpha: 0, y: -30 },
            { autoAlpha: 0.4, y: 0, ease: "expo.easeOut" },
            "title+=0.6"
          )
          .fromTo(
            ".paradigm__txt-desc2",
            0.4,
            { autoAlpha: 0, y: -30 },
            { autoAlpha: 0.4, y: 0, ease: "expo.easeOut" },
            "title+=0.8"
          )
          .fromTo(
            ".paradigm__chatting-view",
            0.5,
            { autoAlpha: 0, y: -30 },
            { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
            "title+=1.0"
          )
          .fromTo(
            ".scroll-btn",
            0.5,
            { autoAlpha: 0, y: 30 },
            { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
            "title+=1.0"
          );
      });

    $(".paradigm-slick").slick("slickGoTo", 0);
    if (this.autoPlay) {
      this.start();
      this.setIsIntro(false);
    }
  },
};
</script>

<style lang="scss">
@mixin settitle($nation) {
  $columns: 3;
  @for $i from 0 through $columns {
    div[data-slick-index="#{$i}"] {
      .paradigm {
        &__txt {
          &-tit {
            @include bg(
              $bg: "../assets/img/#{$nation}/paradigm_tit#{$i+1}_#{$nation}.png",
              $cover: cover
            );
            @include bp(tablet) {
              @include bg(
                $bg:
                  "../assets/img/#{$nation}/paradigm_tit#{$i+1}_#{$nation}_m.png"
              );
            }
          }
        }
      }
    }
  }
}

:lang(en) {
  div[data-slick-index="0"],
  div[data-slick-index="1"] {
    .paradigm {
      &__txt {
        &-desc {
          top: 370px;
          @include bp(tablet) {
            top: 210px;
          }
        }
      }
    }
  }

  div[data-slick-index="0"] {
    .paradigm {
      &__txt {
        &-desc2 {
          top: 405px;
        }
        &-desc {
          span {
            @include bp(tablet) {
              display: block;
            }
          }
        }
      }
    }

    @include bp(tablet) {
      .paradigm {
        &__txt {
          &-desc2 {
            top: 220px;
          }
        }
      }
    }
  }

  div[data-slick-index="1"] {
    .paradigm {
      &__chatting {
        &-view {
          @include bg(
            $bg: "../assets/img/en/paradigm_chatting_img_en.png",
            $cover: cover
          );
          @include bp(tablet) {
            @include bg($bg: "../assets/img/en/paradigm_chatting_img_en_m.png");
            margin-top: -150px;
          }
        }
      }
    }
  }

  .paradigm {
    &__txt {
      &-bg {
        &::before {
          display: block;
          content: "";
          width: 1186px;
          height: 255px;
          @include bg($bg: "../assets/img/sub_bg_en.png");

          margin-top: 199px;
          @include bp(tablet) {
            display: none;
          }
        }
      }
      &-tit {
        width: 1347px;
        height: 329px;
        margin-left: -673px;
        margin-top: -50px;
        background-size: auto !important;
        @include bp(tablet) {
          background-size: cover !important;
        }
      }
      &-desc2 {
        @include bp(tablet) {
          top: 175px !important;
        }
      }
    }
  }
  @include settitle($nation: en);
  @include bp(tablet) {
    .slick-slide {
      .paradigm {
        &__txt {
          &-tit {
            width: 264px;
            height: 137px;
            margin-left: -132px;
            top: 130px;
          }
        }
      }
    }
  }
}
:lang(ja) {
  div[data-slick-index="0"] {
    @include bp(tablet) {
      .paradigm {
        &__txt {
          &-desc {
            top: 235px;
          }
          &-desc {
            span {
              @include bp(tablet) {
                display: block;
              }
            }
          }
        }
      }
    }
  }
  div[data-slick-index="1"] {
    .paradigm {
      &__chatting {
        &-view {
          @include bg(
            $bg: "../assets/img/ja/paradigm_chatting_img_ja.png",
            $cover: cover
          );
          @include bp(tablet) {
            @include bg($bg: "../assets/img/ja/paradigm_chatting_img_ja_m.png");
          }
        }
      }
    }
  }
  div[data-slick-index="2"] {
    @include bp(tablet) {
      .paradigm {
        &__txt {
          &-desc {
            top: 150px;
          }
          &-desc2 {
            top: 150px;
          }
        }
      }
    }
  }
  @include settitle($nation: ja);
  @include bp(tablet) {
    .slick-slide {
      .paradigm {
        &__txt {
          &-tit {
            width: 283px;
            height: 137px;
            margin-left: -141px;
          }
          &-desc2 {
            span {
              @include bp(tablet) {
                display: block;
              }
            }
          }
        }
      }
    }
  }

  .paradigm {
    &__txt {
      &-tit {
        width: 1248px;
        height: 140px;
        margin-left: -624px;
        //margin-top: -50px;
        // background-size: auto !important;
      }
    }
  }
}
:lang(zh) {
  div[data-slick-index="1"] {
    .paradigm {
      &__chatting {
        &-view {
          @include bg(
            $bg: "../assets/img/zh/paradigm_chatting_img_zh.png",
            $cover: cover
          );
          @include bp(tablet) {
            @include bg($bg: "../assets/img/zh/paradigm_chatting_img_zh_m.png");
          }
        }
      }
    }
  }
  div[data-slick-index="2"] {
    @include bp(tablet) {
      .paradigm {
        &__txt {
          &-desc {
            top: 159px;
          }
          &-desc2 {
            @include bp(tablet) {
              top: 160px;
            }
          }
        }
      }
    }
  }
  @include settitle($nation: zh);
  @include bp(tablet) {
    .slick-slide {
      .paradigm {
        &__txt {
          &-tit {
            width: 293px;
            height: 124px;
            margin-left: -146px;
          }
          &-desc {
            top: 203px;
          }
          &-desc2 {
            top: 200px;
          }
        }
      }
    }
  }

  .paradigm {
    &__txt {
      &-tit {
        width: 981px;
        height: 153px;
        margin-left: -490px;
        //margin-top: -50px;
        //background-size: auto !important;
      }
    }
  }
}

.wrapper {
  width: 100%;
  height: 100%;
}

@media (min-width: 1261px) {
  .paradigm-slick {
    .slick-dots {
      @include bg($bg: "../assets/img/icon_slick_dot-paradigm-bg.png");
      @include position(
        $position: absolute,
        $left: 50%,
        $bottom: 0,
        $width: 998px,
        $height: 350px
      );
      background-size: 100%;
      li {
        margin: 0;
        button {
          width: 160px;
          height: 102px;
          @include bg($bg: "../assets/img/icon_slick_dot-paradigm.png");
          background-position: -15px -24px;
          margin-top: 150px;
        }
        &:nth-of-type(2) {
          button {
            background-position-x: -175px;
          }
        }
        &:nth-of-type(3) {
          button {
            background-position-x: -337px;
          }
        }
        &:nth-of-type(4) {
          button {
            background-position-x: -497px;
          }
        }
        &.slick-active {
          button {
            background-position-y: -143px;
          }
        }
      }
    }
    .slick-arrow {
      @include position(
        $position: absolute,
        $left: 50%,
        $bottom: 119px,
        $width: 39px,
        $height: 42px
      );
      @include bg($bg: "../assets/img/icon_slick_arrow-paradigm.png");
      top: auto;

      &.slick-prev {
        margin-left: -370px;
      }
      &.slick-next {
        margin-left: 329px;
      }
    }
  }
}

.paradigm-slick {
  height: 100%;
  .slick-list {
    height: 100%;
    .slick-track {
      height: 100%;
      .slick-slide {
        & > div {
          height: 100%;
        }
      }
    }
  }
  .slick-arrow {
    @include bp(tablet) {
      width: 59px !important;
      height: 56px !important;
      &.slick-prev {
        left: 5px !important;
      }
      &.slick-next {
        right: 5px !important;
      }
    }
  }
}

$columns: 3;
@for $i from 0 through $columns {
  div[data-slick-index="#{$i}"] {
    .paradigm {
      &__bg {
        &-view {
          @include bg(
            $bg: "../assets/img/paradigm_bg#{$i+1}.png",
            $cover: cover
          );
          background-position: center center;
        }
      }
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/ko/paradigm_tit#{$i+1}.png");
        }
      }
    }
  }
}
@include bp(tablet) {
  .slick-slide {
    .paradigm {
      &__txt {
        &-bl {
          display: none;
        }
        &-bg {
          display: none;
        }
        &-tit {
          width: 300px;
          height: 137px;
          margin-left: -150px;
          top: 80px;
          background-size: 100% auto;
        }
        &-desc {
          font-size: 13px;
          top: 195px;
        }
        &-desc2 {
          font-size: 13px;
          top: 190px;
        }
      }
    }
  }

  div[data-slick-index="0"] {
    .paradigm {
      &__bg {
        &-view {
          @include bg($bg: "../assets/img/paradigm_bg1_m.png");
        }
      }
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/paradigm_tit1_m.png");
        }
        &-desc2 {
          @include bp(tablet) {
            display: none;
          }
        }
      }
    }
  }
  div[data-slick-index="1"] {
    .paradigm {
      &__bg {
        &-view {
          @include bg($bg: "../assets/img/paradigm_bg2_m.png");
        }
      }
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/paradigm_tit2_m.png");
        }
      }
    }
  }
  div[data-slick-index="2"] {
    .paradigm {
      &__bg {
        &-view {
          @include bg($bg: "../assets/img/paradigm_bg3_m.png");
        }
      }
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/paradigm_tit3_m.png");
        }
        &-desc {
          @include bp(tablet) {
            display: none;
          }
        }
      }
    }
  }
  div[data-slick-index="3"] {
    .paradigm {
      &__bg {
        &-view {
          @include bg($bg: "../assets/img/paradigm_bg4_m.png");
        }
      }
      &__txt {
        &-tit {
          @include bg($bg: "../assets/img/paradigm_tit4_m.png");
        }
        &-desc {
          @include bp(tablet) {
            display: none;
          }
        }
      }
    }
  }
}
/*
.wrap-preorder-btn {
  @include position(
    $position: absolute,
    $width: 290px,
    $height: 224px,
    $bottom: 0,
    $right: 10px
  );
  @include hide-text;
  @include bg($bg: "../assets/img/ko/btn_preorder_pc_ko.png");
  background-position: 20px 7px;
  z-index: 30;

  a {
    width: 100%;
    height: 100%;
    display: block;
    &:before {
      opacity: 0;
      display: inline-block;
      content: "";
      @include bg($bg: "../assets/img/ko/btn_preorder_pc_ko.png");
      background-position: 20px -243px;
      @include position(
        $position: absolute,
        $width: 290px,
        $height: 224px,
        $bottom: 0,
        $right: 0
      );
      transition: 0.3s;
    }
    &:hover:before {
      opacity: 1;
      background-position: 10px -249px !important;
      //z-index: 11 !important;
      //background-position-y: -245px !important;
    }
  }
  @include bp(tablet) {
    width: 140.5px;
    height: 137px;
    @include bg($bg: "../assets/img/ko/btn_preorder_m.png");
    background-size: contain;
    a {
      &:before {
        display: none;
      }
    }
  }
}*/

.paradigm {
  height: 100%;
  position: relative;
  &__bg {
    @include position($width: 100%, $height: 100%);
    overflow: hidden;
    &-view {
      @include position(
        $position: absolute,
        $top: 0,
        $left: 0,
        $width: 100%,
        $height: 100%
      );
      background-size: 100%;
    }
  }
  &.__contents {
    @include position($position: absolute, $top: 50%, $left: 50%);
    transform: translateX(-50%) translateY(-50%);
    width: 100%;
    height: 100%;
  }
  &__txt {
    @include position(
      $position: absolute,
      $width: 100%,
      $height: 563px,
      $top: 24px,
      $left: 50%
    );
    &-bg {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: 0,
        $left: 50%
      );
      @include bg($bg: "../assets/img/tit_bg.png", $position: 50% 0);
      transform-origin: 50% 180px;
      transform: scale(0.8);
      &::before {
        display: block;
        content: "";
        width: 1110px;
        height: 322px;
        @include bg($bg: "../assets/img/sub_bg.png");
        @include position($position: absolute, $top: 50%, $left: 50%);
        margin-top: 111px;
        @include bp(tablet) {
          display: none;
        }
      }
    }
    margin-top: -70px;
    &-bl {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 34px,
        $top: 157px,
        $left: 50%
      );
      > span {
        display: block;
        @include position(
          $position: absolute,
          $width: 34px,
          $height: 34px,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_b.png");
        &:nth-child(1) {
          background-position-x: 0;
        }
        &:nth-child(2) {
          background-position-x: -34px;
        }
        &:nth-child(3) {
          background-position-x: -68px;
        }
      }
      > hr {
        border: none;
        @include position(
          $position: absolute,
          $width: 96px,
          $height: 14px,
          $top: 2px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_l.png");
        margin-left: 17px;
        &:last-child {
          @include bg($bg: "../assets/img/tit_icon_r.png");
          margin-left: -113px;
        }
      }
    }
    &-tit {
      @include position(
        $position: absolute,
        $width: 939px,
        $height: 126px,
        $top: 200px,
        $left: 50%
      );
      @include hide-text;
      @include bp(tablet) {
        background-size: cover !important;
      }
    }
    &-desc {
      @include position(
        $position: absolute,
        $width: 100%,
        $top: 315px,
        $left: 50%
      );
      font-size: 19px;
      text-align: center;
      letter-spacing: -0.9px;
      line-height: 1.8em;
      opacity: 0.4;
      .zh &,
      .en & {
        letter-spacing: 0px;
      }
    }
    &-desc2 {
      @include position(
        $position: absolute,
        $width: 100%,
        $top: 345px,
        $left: 50%
      );
      font-size: 19px;
      text-align: center;
      letter-spacing: -0.9px;
      line-height: 1.8em;
      opacity: 0.4;
      .zh &,
      .en & {
        letter-spacing: 0px;
      }
      span {
        @include bp(tablet) {
          display: block;
        }
      }
    }
  }
  &__chatting {
    &-view {
      position: absolute;
      left: 50%;
      margin-left: -696px;
      top: 130px;
      width: 1501px;
      height: 848px;
      @include bg(
        $bg: "../assets/img/ko/paradigm_chatting_img_ko.png",
        $cover: cover
      );
      background-position: center center;
      @include bp(tablet) {
        @include bg($bg: "../assets/img/ko/paradigm_chatting_img_ko_m.png");
        @include position(
          $position: absolute,
          $width: (
            358px,
          ),
          $height: (
            405px,
          ),
          $top: 50%,
          $left: 50%
        );
        margin-left: -180px;
        margin-top: -161px;
      }
    }
  }
}
div[data-slick-index="1"] {
  .paradigm {
    &__txt {
      z-index: 10;
    }
  }
}

.paradigm-slick + .scroll-btn {
  @include bp(tablet) {
    width: 56px;
    height: 42px;
    margin-left: -28px;
    .scroll-btn__con {
      background-image: url("../assets/img/icon_down_m1.png");

      &::after {
        display: none;
      }
    }
  }
}
</style>
